import app from '@/app';
import router from '@/router';

// route params are now async in vue router 4. need to wait for them before
// mounting or params will be inconsistently available on created/mounted.
router.isReady().then(() => {
  app.mount('#app');
});
